import {OnInit, Component, Input, HostListener, ElementRef} from '@angular/core';

declare const $: any;

@Component({
    selector: 'list-with-hint',
    templateUrl: './list-with-hint.component.html',
    styleUrls: ['./list-with-hint.component.scss']
})
export class ListWithHintComponent implements OnInit {
    @Input() listItems;
    @Input() showPeriod = true;
    @Input() parentElementSelector: string;
    @Input() property: string;

    public isShow: boolean = false;
    public isDirectionTop: boolean = false;

    private parentRect;
    private element;

    constructor(private _eref: ElementRef) {}

    ngOnInit() {
        if (this.parentElementSelector) {
            this.parentRect = document.querySelector(this.parentElementSelector).getBoundingClientRect();
            this.element = this._eref.nativeElement;
        }
    }

    public toggle(): void {
        if (this.parentRect) {
            this.isDirectionTop = this.isOverflowBottom();
        } else {
            this.isDirectionTop = false;
        }

        this.isShow = !this.isShow;
    }

    private isOverflowBottom(): boolean {
        if (this.parentRect) {
            const maxHeight = this.parentRect.bottom;

            const elementReact = this.element.getBoundingClientRect();
            const dropDownHeight = this.element.querySelector('.list-items__drop-down').getBoundingClientRect().height;
            const elementBottomPosition = elementReact.bottom + dropDownHeight;

            return elementBottomPosition > maxHeight;
        }

        return false;
    }

    public getDisplayName(item): string {
        return !this.property ? item : item[this.property];
    }

    @HostListener('document:click', ['$event.target'])
    private hide(targetElement: HTMLElement): void {
        if (!this._eref.nativeElement.contains(targetElement)) {
            this.isShow = false;
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/list-with-hint/list-with-hint.component.ts